import * as moment from 'moment';

import RoutingActions from '../../../actions/RoutingActions';
import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';

import GuestListStore from '../../../stores/GuestListStore';
import UserStore from '../../../stores/UserStore';
import RoutingStore from '../../../stores/RoutingStore';
import PosCartActions from '../../../actions/PosCartActions';
import UserActions from '../../../actions/UserActions';

class CheckInToPos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false
        };

        this.enterPos = this.enterPos.bind(this);
        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
    }

    componentDidMount() {
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
    }

    componentWillUnmount() {
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
    }

    onGuestListStoreChange() {
        if (!this.state.loading) {
            return;
        }

        let guest = this.props.guest;

        if (!GuestListStore.getGuestById(guest.Guest_id)) {
            this.setState({ loading : false }, () => {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : 'This user is not checked in'
                });
            })
        } else {
            Promise.resolve().then(() => { 
                let route = RoutingStore.getRoute();

                if (route[0] !== 'pos') {
                    RoutingActions.updateRoute('pos/'+guest.Guest_id);
                    GuestListActions.selectGuestForPos(guest);
                }

                PopupActions.close();
            });
        }
    }

    enterPos() {
        let selectedLocation = UserStore.getState().selectedLocation;
        const guest = this.props.guest;

        if (this.state.loading || this.props.loading) {
            return;
        }

        if (!UserStore.getState().selectedRegister) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Please select a register first'
            });
            return;
        }

        if (guest.CurrentRegister > 0 && guest.CurrentRegister !== UserStore.getState().selectedRegister.id) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'User is bound to another register.'
            });
            return;
        }

        if (this.props.guest.Attestation.toLowerCase() === 'no' && selectedLocation.Attestation) {
            NotificationActions.error('Patient Has not completed the Attestation Document. You cannot Proceed.')
            return;
        }

        let attestationExpirationDate = moment(this.props.guest.AttestationExpirationDate);
        if ((moment().isAfter(attestationExpirationDate, 'day') || moment().isSame(attestationExpirationDate, 'day')) && selectedLocation.Attestation) {
            NotificationActions.error('Patient Attestation Document has expired. You cannot Proceed.')
            return;
        }

        if (selectedLocation.CanUseMassDPHIntegration && !UserStore.getState().validDPHCredentials && guest.PatientType !== 'Recreational' && selectedLocation.RequireValidAllotmentCredentials) {
            NotificationActions.error('Your DPH Credentials are invalid! Go to settings and update to continue.', true);
            return;
        }

        if (selectedLocation.RequireValidDL) {
            let ids = this.props.guest.identifications.filter(x => {
                return x.type === 'DriversLicenseId';
            });

            let dl = ids.length > 0 ? ids[0] : '';

            let date = moment(dl.ExpirationDate).format('YYYY-MM-DD');

            if (date === 'Invalid date' || moment(date).isBefore(moment())) {
                NotificationActions.error('Patient\'s Driver\'s License has expired.');
                return;
            }
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(this.props.guest)) {

            NotificationActions.error('Patient\'s MMJ License has expired.');
            return;
        };

        this.setState({ loading : true }, () => {
            const route = RoutingStore.getRoute();
            if (route[0] === 'pos') {
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            }
            GuestListActions.loadGuestList(false);
        });
    }

    render() {
        let valid = UserStore.getState().selectedRegister;

        return (
            <button
                className={'btn-green '+(!valid ? 'btn-green__disabled' : '')}
                onClick={this.enterPos}>

                { this.state.loading ? 'Loading' : 'ENTER POS' }
            </button>
        );
    }
}

export default CheckInToPos;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/EnterPos.react.jsx